module.exports = new __parcel__URL__("ham-company.5f8ce858.png").toString();